import { DatePicker } from 'antd';
import React from 'react';

export const LCDatePicker = props => <DatePicker {...props} />;
